'use strict';

var utils = require('../util/utils');

/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */
function showConsentModal() {
    $('#consentTracking').modal('show');
}

module.exports = function () {
    const consent = utils.getCookie('cookie_consent');
    const privacy = utils.getCookie('cookie_privacy');
    var $page = $('.page');

    if (!consent) {
        showConsentModal();
    }

    if ($page.hasClass('logged-in') && !privacy) {
        $('#privacyPolicy').modal('show');
    }

    $('body').on('showConsent', showConsentModal);

    $('body').on('click', '#closeConsentBanner', function () {
        $('#consentTracking').modal('hide');
        utils.setCookie('cookie_consent', 'true', 365);
    });

    $('body').on('click', '#acceptPrivacy', function () {
        $('#privacyPolicy').modal('hide');
        utils.setCookie('cookie_privacy', 'true', 365);
    });

    $('body').on('hidden.bs.modal', '#consentTracking', function () {
        $('body').trigger('showLoginModal');
    });
};
